module.exports = __webpack_public_path__ + "img/ranking-list.19bd4e62.png";